import {toast} from "react-toastify";

/**
 * @return {Object}
 */
function Validator(job, notify) {
  const required = {department: 'Department'};

  const requiredNested = {
    vehicle: "registration",
    customer: "id"
  };

  let missing = [];
  let missingPartSuppliers = [];
  let invalidWorkTypes = [];

  for (let field in required) {
    if (!job[field] || job[field].length === 0) {
      missing.push(required[field]);
    }
  }

  for (let field in requiredNested) {
    if (
      !job[field] ||
      !job[field][requiredNested[field]] ||
      job[field][requiredNested[field]].length === 0
    ) {
      missing.push(field);
    }
  }

  job.estimated_work_items.forEach(item => {
    item.parts.forEach(part => {
      if (!part.supplier || !part.supplier.id) {
        missingPartSuppliers.push(part.name || "Unnamed Part");
      }
    });
  });

  job.estimated_work_items.forEach((item, index) => {
    if(!item.work_type){
      invalidWorkTypes.push(item.description || ("Work Item "+(index+1)))
    }
  });

  if (notify) {
    missing.forEach(name => {
      toast.warning(
        `You must specify a ${name}`,{position: "top-right"});
    });

    missingPartSuppliers.forEach(name => {
      toast.warning(
        `Part ${name} is missing a supplier!`,{position: "top-right"});
    });

    invalidWorkTypes.forEach(name => {
      toast.warning(
          `You must specify a work type for ${name}`, {position: "top-right"} );
    });
  }


  return {
    missingPartSuppliers: missingPartSuppliers,
    missing: missing,
    invalidWorkTypes: invalidWorkTypes,
    result: missing.length === 0 && missingPartSuppliers.length === 0 && invalidWorkTypes.length === 0
  };
}

export default Validator;
